import { Outlet, useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { useEffect, useState } from "react";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { AppBox, AppContainer, AppModal, NotFound } from "../../../commons/components";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import setDocumentTitle from "../../../commons/utilities/document-title";
import { cleanUpManageTeamCompetitions } from "../../../redux/slices/football/admin/team/manage-team-competitions-slice";
import { cleanUpStepperFormData } from "../../../redux/slices/stepper-form-slice";
import SubTeamManageDetailHeader from "./components/SubTeamManageDetailHeader";
import IconBranch from "../../../commons/components/icons/branch";
import {
  cleanUpSubTeamInfo,
  fetchManageSubTeam,
} from "../../../redux/slices/football/admin/team/sub-team/manage-sub-team-slice";
import SubTeamAddEdit from "../teams/components/teamSubTeam/teamAddEdit/SubTeamAddEdit";
import { cleanUpManageStanding } from "../../../redux/slices/football/admin/competition/manage-competition-season-standing-slice";
import { cleanUpFetchedTeamData } from "../../../redux/slices/football/fetched-team-slice";

export default function SubTeamDetailManage() {
  const { teamId, subTeamId } = useParams();
  const dispatch = useAppDispatch();
  const [isEditTeam, setIsEditTeam] = useState(false);
  const { subTeamInfo, subTeamInfoStatus } = useAppSelector((state) => state.footballManageSubTeam);
  useEffect(() => {
    dispatch(
      fetchManageSubTeam({
        teamId: Number(teamId),
        subTeamId: Number(subTeamId),
      })
    );
  }, [subTeamId]);

  useEffect(() => {
    if (subTeamInfoStatus === StatusEnum.Failed) {
      return () => {
        dispatch(cleanUpSubTeamInfo());
      };
    }
  }, [subTeamInfoStatus]);

  useEffect(() => {
    dispatch(setPageTitle(""));
    return () => {
      dispatch(cleanUpSubTeamInfo());
      dispatch(cleanUpFetchedTeamData());
      dispatch(cleanUpManageTeamCompetitions());
      dispatch(cleanUpManageStanding());
    };
  }, []);

  useEffect(() => {
    setDocumentTitle([`${subTeamInfo.shortName}`, `${subTeamInfo.parent.shortName}`, "Manage"]);
  }, [subTeamInfo]);

  const handleAfterEdit = () => {
    setIsEditTeam(false);
    dispatch(
      fetchManageSubTeam({
        teamId: Number(teamId),
        subTeamId: Number(subTeamId),
      })
    );
  };

  const handleEditClose = () => {
    setIsEditTeam(false);
    dispatch(cleanUpStepperFormData());
  };

  return (
    <AppContainer>
      {subTeamInfoStatus === StatusEnum.Failed ? (
        <NotFound />
      ) : (
        <AppBox mt="md" flexDirection="column" gap="md">
          <SubTeamManageDetailHeader onEditSubTeam={() => setIsEditTeam(true)} />
          <Outlet />
        </AppBox>
      )}
      <AppModal
        opened={isEditTeam}
        modalSize="lg"
        onClose={handleEditClose}
        title="Edit Sub-team"
        titleIcon={<IconBranch />}
        withoutButtons
      >
        <SubTeamAddEdit teamInfo={subTeamInfo.parent} subTeamData={subTeamInfo} onSave={handleAfterEdit} />
      </AppModal>
    </AppContainer>
  );
}
